module.exports = __webpack_public_path__ + "static/media/Gadget.0763c7ba.svg";